import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { useApiContext } from '@trg/api';
import type { FooterApiResponse } from './footer-api.type';

export const footerApiPath = '/headerfooter/footer';

export function useFooterApi() {
  const { host } = useApiContext();
  if (host === undefined) throw new Error('ApiContext not found');

  return useQuery({
    queryKey: ['footer'],
    queryFn: async () => {
      const { data } = await axios.get<FooterApiResponse>(host + footerApiPath);
      return data;
    },
  });
}
